import { render, staticRenderFns } from "./nutrition.vue?vue&type=template&id=6da37ca0"
import script from "./nutrition.vue?vue&type=script&lang=js"
export * from "./nutrition.vue?vue&type=script&lang=js"
import style0 from "./nutrition.vue?vue&type=style&index=0&id=6da37ca0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports